module.exports = __webpack_public_path__ + "img/logo.3568bc6f.png";